// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ {
    display: flex;
  }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL {
      margin-left: 22px;
    }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL h2 {
        font-size: 21px;
        color: #1b2432;
        letter-spacing: 0;
        margin-bottom: 5px;
      }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___description--bija1 {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
      }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD {
    margin: 32px 0 0 0;
  }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb {
      display: flex;
      flex-direction: column;
      width: 100%;
      box-sizing: border-box;
      gap: 0;
    }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___programButtons--u8QcD {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
      }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___programButton--trtat {
        text-transform: none;
      }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___currentProgram--Wo8fU {
        margin-top: 12px;
        font-size: 13px;
        color: #1b2432;
      }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___conversionSummary--WxBzd {
        margin-top: 8px;
        font-size: 12px;
        color: #6d717a;
      }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___convertButton--g9teK {
        text-transform: none;
      }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ {
    display: flex;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL {
      margin-left: 0;
    }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL h2 {
        font-size: 15px;
        font-weight: 500;
        color: #1b2432;
        margin-bottom: 8px;
      }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___description--bija1 {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
      }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD {
    margin-top: 20px;
  }

/* Match spacing behavior from .paper in embedded mode */

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .MuiFormHelperText-root {
    margin-top: 4px;
    margin-bottom: 0;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .MuiFormControl-root {
    width: 100%;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .MuiFormControl-marginNormal {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .MuiTextField-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS .MuiFormControlLabel-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactEmbeddedBlock--Kn8qZ {
  padding: 16px 0;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactPaper--e9rN9 {
  width: 100%;
  max-width: 100%;
  margin: 24px 0 0 0;
  padding: 22px;
  box-sizing: border-box;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactPaper--e9rN9 .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL {
      margin-left: 14px;
    }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactPaper--e9rN9 .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL h2 {
        font-size: 17px;
      }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactPaper--e9rN9 .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD {
    margin-top: 24px;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactRow--xaH8H {
  flex-direction: column !important;
  align-items: flex-start !important;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactRow--xaH8H .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___programButtons--u8QcD {
  width: 100%;
  margin-top: 12px;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactRow--xaH8H .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___programButton--trtat {
  flex: 1;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___formSection--pkBmx {
  margin-top: 0;
  margin-bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___formSection--pkBmx:first-child {
    margin-top: 0;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___formSection--pkBmx:last-child {
    margin-bottom: 0;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___convertTypeSection--DWW3x {
  margin-top: 0 !important;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___uniformSection--qQK7o {
  margin-top: 16px !important;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountSection--n9L9H {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountRow--yieNE {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountField--vVAV0 {
  flex: 0 0 50%;
  max-width: 50%;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountNote--UThgr {
  flex: 1;
  font-size: 12px;
  color: #6d717a;
  line-height: 18px;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountNoteError--nQQki {
  color: #d32f2f;
}

@media only screen and (max-width: 768px) {
  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountRow--yieNE {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountField--vVAV0 {
    flex: 1 1 auto;
    max-width: 100%;
    width: 100%;
  }

  .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountNote--UThgr {
    width: 100%;
  }
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___dateSection--bgRX9 {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  gap: 8px;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___dateSection--bgRX9 .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___dateLabel--ymeEs {
    display: block;
    font-size: 14px;
    margin-bottom: 0;
    color: #666;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___actionSection--WFbYB {
  margin-top: 0;
  margin-bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___actionSection--WFbYB .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___buttonGroup--CRGzE {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: nowrap;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___actionSection--WFbYB .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___buttonGroup--CRGzE button {
      min-width: 120px;
      flex-shrink: 0;
    }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactRow--xaH8H .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___actionRow--RoAB8 {
  width: 100%;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactRow--xaH8H .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___convertButton--g9teK {
  width: 100%;
}

/* Global form helper text spacing */

/* MUI FormHelperText override */

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .MuiFormHelperText-root {
    margin-top: 4px;
    margin-bottom: 0;
  }

/* MUI FormControl spacing */

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .MuiFormControl-root {
    width: 100%;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .MuiFormControl-marginNormal {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

/* MUI TextField spacing */

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .MuiTextField-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

/* MUI FormControlLabel spacing */

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky .MuiFormControlLabel-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

/* Company Bank Account-style row (mirrors components/Features/styles.pcss) */

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTable--aQSDi {
  margin: 0;
  border: 1px solid #dddee0;
  border-radius: 4px;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableRow--bMKtn {
  height: 48px !important;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableRow--bMKtn .components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableCell--oUZR6 {
    border-bottom: none !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableRow--bMKtn td:first-child {
    padding-left: 24px !important;
  }

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableCell--oUZR6 {
  font-size: 15px !important;
  padding: 10px 30px 10px 24px !important;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardDescription--jWYJU {
  font-size: 13px;
  color: #6d717a;
  font-weight: normal;
  max-width: 320px;
  line-height: 15px;
  overflow-wrap: break-word;
  white-space: normal;
  margin-top: 6px;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardValueCell--3cilV {
  text-align: left !important;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardValueContainer--SKSiH {
  display: flex;
  justify-content: space-between;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardValueContent--_Ybkz {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  font-weight: 600;
  padding-left: 18px;
}

.components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___editRewardProgram--OfC58 {
  font-size: 15px;
  color: #318afb !important;
  letter-spacing: 0;
  text-align: right;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/CommercialRewards/RewardProgramConversion/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AA4DlB;;EA1DE;IACE,aAAa;EAkBf;;EAhBE;MACE,iBAAiB;IAcnB;;EAZE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;MACpB;;EAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EAIJ;IACE,kBAAkB;EAmCpB;;EAjCE;MACE,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,sBAAsB;MACtB,MAAM;IA2BR;;EAzBE;QACE,aAAa;QACb,SAAS;QACT,eAAe;MACjB;;EAEA;QACE,oBAAoB;MACtB;;EAEA;QACE,gBAAgB;QAChB,eAAe;QACf,cAAc;MAChB;;EAEA;QACE,eAAe;QACf,eAAe;QACf,cAAc;MAChB;;EAEA;QACE,oBAAoB;MACtB;;AAKN;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;AAuDxB;;AArDE;IACE,aAAa;EAkBf;;AAhBE;MACE,cAAc;IAchB;;AAZE;QACE,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;MACpB;;AAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;AAIJ;IACE,gBAAgB;EAClB;;AAEA,wDAAwD;;AACxD;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEA;IACE,WAAW;IACX,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;EAC5B;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AAexB;;AAZI;MACE,iBAAiB;IAKnB;;AAHE;QACE,eAAe;MACjB;;AAIJ;IACE,gBAAgB;EAClB;;AAGF;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AASxB;;AAPE;IACE,aAAa;EACf;;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,QAAQ;AAQV;;AANE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;AAGF;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AAgBxB;;AAdE;IACE,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;EAMnB;;AAJE;MACE,gBAAgB;MAChB,cAAc;IAChB;;AAIJ;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,oCAAoC;;AAElC,gCAAgC;;AAChC;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEA,4BAA4B;;AAC5B;IACE,WAAW;IACX,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEA,0BAA0B;;AAC1B;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEA,iCAAiC;;AACjC;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;EAC5B;;AAGF;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6EAA6E;;AAC7E;EACE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AASzB;;AAPE;IACE,8BAA8B;EAChC;;AAEA;IACE,6BAA6B;EAC/B;;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,uDAAuD;EACvD,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n\n  .commercialRewardsHeader {\n    display: flex;\n\n    .text {\n      margin-left: 22px;\n\n      h2 {\n        font-size: 21px;\n        color: #1b2432;\n        letter-spacing: 0;\n        margin-bottom: 5px;\n      }\n\n      .description {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n      }\n    }\n  }\n\n  .container {\n    margin: 32px 0 0 0;\n\n    .row {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      box-sizing: border-box;\n      gap: 0;\n\n      .programButtons {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n      }\n\n      .programButton {\n        text-transform: none;\n      }\n\n      .currentProgram {\n        margin-top: 12px;\n        font-size: 13px;\n        color: #1b2432;\n      }\n\n      .conversionSummary {\n        margin-top: 8px;\n        font-size: 12px;\n        color: #6d717a;\n      }\n\n      .convertButton {\n        text-transform: none;\n      }\n    }\n  }\n}\n\n.embeddedBlock {\n  width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n\n  .commercialRewardsHeader {\n    display: flex;\n\n    .text {\n      margin-left: 0;\n\n      h2 {\n        font-size: 15px;\n        font-weight: 500;\n        color: #1b2432;\n        margin-bottom: 8px;\n      }\n\n      .description {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n      }\n    }\n  }\n\n  .container {\n    margin-top: 20px;\n  }\n\n  /* Match spacing behavior from .paper in embedded mode */\n  :global(.MuiFormHelperText-root) {\n    margin-top: 4px;\n    margin-bottom: 0;\n  }\n\n  :global(.MuiFormControl-root) {\n    width: 100%;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  :global(.MuiFormControl-marginNormal) {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  :global(.MuiTextField-root) {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  :global(.MuiFormControlLabel-root) {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\n.compactEmbeddedBlock {\n  padding: 16px 0;\n}\n\n.compactPaper {\n  width: 100%;\n  max-width: 100%;\n  margin: 24px 0 0 0;\n  padding: 22px;\n  box-sizing: border-box;\n\n  .commercialRewardsHeader {\n    .text {\n      margin-left: 14px;\n\n      h2 {\n        font-size: 17px;\n      }\n    }\n  }\n\n  .container {\n    margin-top: 24px;\n  }\n}\n\n.compactRow {\n  flex-direction: column !important;\n  align-items: flex-start !important;\n}\n\n.compactRow .programButtons {\n  width: 100%;\n  margin-top: 12px;\n}\n\n.compactRow .programButton {\n  flex: 1;\n}\n\n.formSection {\n  margin-top: 0;\n  margin-bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.convertTypeSection {\n  margin-top: 0 !important;\n}\n\n.uniformSection {\n  margin-top: 16px !important;\n}\n\n.amountSection {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.amountRow {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.amountField {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.amountNote {\n  flex: 1;\n  font-size: 12px;\n  color: #6d717a;\n  line-height: 18px;\n}\n\n.amountNoteError {\n  color: #d32f2f;\n}\n\n@media only screen and (max-width: 768px) {\n  .amountRow {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .amountField {\n    flex: 1 1 auto;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .amountNote {\n    width: 100%;\n  }\n}\n\n.dateSection {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  gap: 8px;\n\n  .dateLabel {\n    display: block;\n    font-size: 14px;\n    margin-bottom: 0;\n    color: #666;\n  }\n}\n\n.actionSection {\n  margin-top: 0;\n  margin-bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n\n  .buttonGroup {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    flex-wrap: nowrap;\n\n    button {\n      min-width: 120px;\n      flex-shrink: 0;\n    }\n  }\n}\n\n.compactRow .actionRow {\n  width: 100%;\n}\n\n.compactRow .convertButton {\n  width: 100%;\n}\n\n/* Global form helper text spacing */\n.paper {\n  /* MUI FormHelperText override */\n  :global(.MuiFormHelperText-root) {\n    margin-top: 4px;\n    margin-bottom: 0;\n  }\n\n  /* MUI FormControl spacing */\n  :global(.MuiFormControl-root) {\n    width: 100%;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  :global(.MuiFormControl-marginNormal) {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  /* MUI TextField spacing */\n  :global(.MuiTextField-root) {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  /* MUI FormControlLabel spacing */\n  :global(.MuiFormControlLabel-root) {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n/* Company Bank Account-style row (mirrors components/Features/styles.pcss) */\n.rewardTable {\n  margin: 0;\n  border: 1px solid #dddee0;\n  border-radius: 4px;\n}\n\n.rewardTableRow {\n  height: 48px !important;\n\n  .rewardTableCell {\n    border-bottom: none !important;\n  }\n\n  td:first-child {\n    padding-left: 24px !important;\n  }\n}\n\n.rewardTableCell {\n  font-size: 15px !important;\n  padding: 10px 30px 10px 24px !important;\n}\n\n.rewardDescription {\n  font-size: 13px;\n  color: #6d717a;\n  font-weight: normal;\n  max-width: 320px;\n  line-height: 15px;\n  overflow-wrap: break-word;\n  white-space: normal;\n  margin-top: 6px;\n}\n\n.rewardValueCell {\n  text-align: left !important;\n}\n\n.rewardValueContainer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.rewardValueContent {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-weight: 600;\n  padding-left: 18px;\n}\n\n.editRewardProgram {\n  font-size: 15px;\n  color: #318afb !important;\n  letter-spacing: 0;\n  text-align: right;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___paper--f7Wky`,
	"commercialRewardsHeader": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___commercialRewardsHeader--aenDQ`,
	"text": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___text--LrvCL`,
	"description": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___description--bija1`,
	"container": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___container--DgKYD`,
	"row": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___row--jQfPb`,
	"programButtons": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___programButtons--u8QcD`,
	"programButton": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___programButton--trtat`,
	"currentProgram": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___currentProgram--Wo8fU`,
	"conversionSummary": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___conversionSummary--WxBzd`,
	"convertButton": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___convertButton--g9teK`,
	"embeddedBlock": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___embeddedBlock--okIwS`,
	"compactEmbeddedBlock": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactEmbeddedBlock--Kn8qZ`,
	"compactPaper": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactPaper--e9rN9`,
	"compactRow": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___compactRow--xaH8H`,
	"formSection": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___formSection--pkBmx`,
	"convertTypeSection": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___convertTypeSection--DWW3x`,
	"uniformSection": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___uniformSection--qQK7o`,
	"amountSection": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountSection--n9L9H`,
	"amountRow": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountRow--yieNE`,
	"amountField": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountField--vVAV0`,
	"amountNote": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountNote--UThgr`,
	"amountNoteError": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___amountNoteError--nQQki`,
	"dateSection": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___dateSection--bgRX9`,
	"dateLabel": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___dateLabel--ymeEs`,
	"actionSection": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___actionSection--WFbYB`,
	"buttonGroup": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___buttonGroup--CRGzE`,
	"actionRow": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___actionRow--RoAB8`,
	"rewardTable": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTable--aQSDi`,
	"rewardTableRow": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableRow--bMKtn`,
	"rewardTableCell": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardTableCell--oUZR6`,
	"rewardDescription": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardDescription--jWYJU`,
	"rewardValueCell": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardValueCell--3cilV`,
	"rewardValueContainer": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardValueContainer--SKSiH`,
	"rewardValueContent": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___rewardValueContent--_Ybkz`,
	"editRewardProgram": `components-CompanyDetails-CommercialRewards-RewardProgramConversion-styles___editRewardProgram--OfC58`
};
module.exports = ___CSS_LOADER_EXPORT___;
